export const getMinimumpaymentAmount = () => {
  const minimumSetting = import.meta.env.REACT_APP_MINIMUM_PAYMENT_AMOUNT;
  const parsedMinimum = parseFloat(minimumSetting);

  // Default to $5.00
  return parsedMinimum || 5.0;
};
